import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import SEOHead from './SEOHead';
import { legalDraftNotice, privacyEmail } from '../content/legalDrafts';
import { scrollTo } from '../utils/smoothScroll';

export const LegalDraftContent = ({ draft, onCookiePreferences }) => (
  <article className="bg-white rounded-2xl p-6 sm:p-12 shadow-sm text-gray-600 leading-relaxed break-words">
    <aside aria-label="Aggiornamento dell’informativa" className="mb-10 p-5 rounded-xl border border-[#d4883a]/40 bg-[#d4883a]/10 text-[#0b114e]">
      <p className="font-semibold">{legalDraftNotice}</p>
      <p className="text-sm mt-2">{draft.introduction}</p>
    </aside>
    {draft.sections.map((section, index) => (
      <section key={section.title} className="mt-10 first:mt-0" aria-labelledby={`${draft.page}-${index}`}>
        <h2 id={`${draft.page}-${index}`} className="text-2xl font-bold text-[#0b114e] mb-4">{index + 1}. {section.title}</h2>
        {section.paragraphs.map(text => <p key={text} className="mb-4">{text}</p>)}
        {section.retention && (
          <dl className="my-6 border border-gray-200 rounded-xl overflow-hidden">
            {section.retention.map(([archive, period]) => (
              <div key={archive} className="grid sm:grid-cols-2 gap-1 sm:gap-6 p-4 border-b last:border-b-0 border-gray-200">
                <dt className="font-semibold text-[#0b114e]">{archive}</dt>
                <dd>{period}</dd>
              </div>
            ))}
          </dl>
        )}
        {section.after?.map(text => <p key={text} className="mb-4">{text}</p>)}
        {section.links && <ul className="space-y-2 text-sm">
          {section.links.map(({ label, href }) => <li key={href}>
            {href.startsWith('/')
              ? <Link to={href} className="text-[#9a5a1c] underline underline-offset-4">{label}</Link>
              : <a href={href} className="text-[#9a5a1c] underline underline-offset-4">{label}</a>}
          </li>)}
        </ul>}
      </section>
    ))}
    <p className="mt-10">Contatto privacy: <a href={`mailto:${privacyEmail}`} className="text-[#9a5a1c] underline">{privacyEmail}</a>.</p>
    {onCookiePreferences && <button type="button" onClick={onCookiePreferences} className="mt-6 px-6 py-3 bg-[#0b114e] text-white rounded-full hover:bg-[#1c2468] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#0b114e]">Modifica preferenze cookie</button>}
  </article>
);

const LegalDraftPage = ({ draft, onCookiePreferences }) => {
  useEffect(() => { scrollTo(0, { immediate: true }); }, []);
  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      <SEOHead page={draft.page} customTitle={`${draft.title} | Nicola Scerni`} customDescription={draft.introduction} />
      <Navbar />
      <section className="bg-[#0b114e] pt-32 pb-16">
        <div className="max-w-[900px] mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6 text-sm"><ArrowLeft className="w-4 h-4" />Torna alla home</Link>
          <h1 className="text-4xl sm:text-5xl font-bold text-white" style={{ fontFamily: 'Georgia, serif' }}>{draft.title}</h1>
          <p className="text-white/80 mt-4">{legalDraftNotice}</p>
        </div>
      </section>
      <main className="py-10 sm:py-16 max-w-[900px] mx-auto px-4 sm:px-6">
        <LegalDraftContent draft={draft} onCookiePreferences={onCookiePreferences} />
      </main>
      <Footer />
    </div>
  );
};

export default LegalDraftPage;
